import {useMemo, useState} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {
	Box,
	Container,
	Typography,
	TextField,
	InputAdornment,
	Grid,
	Card,
	CardActionArea,
	CardContent,
	CardMedia,
	Chip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {userManuals} from 'src/data/userManuals';

export default function UserManualListPage() {
	const fallbackImage = '/static/backgrounds/gradientwavebackground.png';
	const [query, setQuery] = useState('');

	const filtered = useMemo(() => {
		const q = query.trim().toLowerCase();
		if (!q) return userManuals;
		return userManuals.filter((m) => [m.title, m.summary].some((t) => t.toLowerCase().includes(q)));
	}, [query]);

	return (
		<Container maxWidth="md" sx={{py: 4}}>
			<Box sx={{display: 'flex', alignItems: 'center', mb: 3}}>
				<Box sx={{flexGrow: 1}}>
					<Typography variant="h4" sx={{fontWeight: 700}}>
						دليل المستخدم
					</Typography>
					{/* <Typography variant="body2" color="text.secondary">
						Browse guides to run your multi-tenant store smoothly.
					</Typography> */}
				</Box>
			</Box>

			<TextField
				fullWidth
				value={query}
				onChange={(e) => setQuery(e.target.value)}
				placeholder="البحث"
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon />
						</InputAdornment>
					),
				}}
				sx={{mb: 3}}
			/>

			<Grid container spacing={3}>
				{filtered.map((m) => (
					<Grid key={m.slug} item xs={12} sm={6} lg={4}>
						<Card variant="outlined" sx={{height: '100%', display: 'flex', flexDirection: 'column'}}>
							<CardActionArea
								component={RouterLink}
								to={`/manuals/${m.slug}`}
								sx={{height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch'}}
							>
								<CardMedia
									component="img"
									image={m.image || fallbackImage}
									alt={`${m.title} cover`}
									sx={{height: 170, width: '100%', objectFit: 'cover'}}
								/>
								<CardContent sx={{width: '100%'}}>
									<Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1}}>
										<Typography
											variant="h6"
											sx={{
												fontWeight: 600,
												display: '-webkit-box',
												WebkitLineClamp: 2,
												WebkitBoxOrient: 'vertical',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												lineHeight: 1.3,
												minHeight: '2.6em',
											}}
										>
											{m.title}
										</Typography>
									</Box>
									<Typography variant="body2" color="text.secondary" sx={{mt: 1}}>
										{m.summary}
									</Typography>
								</CardContent>
							</CardActionArea>
						</Card>
					</Grid>
				))}

				{filtered.length === 0 && (
					<Grid item xs={12}>
						<Box sx={{textAlign: 'center', py: 6}}>
							<Typography variant="h6">لم يتم العثور على نتائج</Typography>
						</Box>
					</Grid>
				)}
			</Grid>
		</Container>
	);
}
